module.exports = require("net");


//////////////////
// WEBPACK FOOTER
// external "net"
// module id = 52
// module chunks = 0